/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {User} from '../bioplanModels';
// @ts-ignore
import type {WriteUser} from '../bioplanModels';
/**
 * OrganisationUserApi - axios parameter creator
 * @export
 */
export const OrganisationUserApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/users/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersMeGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/users/me`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * An ID will be created in the backend
     * @summary Create user
     * @param {WriteUser} writeUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersPost: async (writeUser: WriteUser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'writeUser' is not null or undefined
      assertParamExists('usersPost', 'writeUser', writeUser);
      const localVarPath = `/users/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(writeUser, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete user by its identifier
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdDelete: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('usersUserIdDelete', 'userId', userId);
      const localVarPath = `/users/{userId}`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get user by its identifier
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('usersUserIdGet', 'userId', userId);
      const localVarPath = `/users/{userId}`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update user
     * @param {string} userId
     * @param {WriteUser} writeUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdPut: async (
      userId: string,
      writeUser: WriteUser,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('usersUserIdPut', 'userId', userId);
      // verify required parameter 'writeUser' is not null or undefined
      assertParamExists('usersUserIdPut', 'writeUser', writeUser);
      const localVarPath = `/users/{userId}`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(writeUser, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OrganisationUserApi - functional programming interface
 * @export
 */
export const OrganisationUserApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OrganisationUserApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get all users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<User>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrganisationUserApi.usersGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersMeGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersMeGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrganisationUserApi.usersMeGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * An ID will be created in the backend
     * @summary Create user
     * @param {WriteUser} writeUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersPost(
      writeUser: WriteUser,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersPost(writeUser, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrganisationUserApi.usersPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete user by its identifier
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersUserIdDelete(
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersUserIdDelete(userId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrganisationUserApi.usersUserIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get user by its identifier
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersUserIdGet(
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersUserIdGet(userId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrganisationUserApi.usersUserIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update user
     * @param {string} userId
     * @param {WriteUser} writeUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersUserIdPut(
      userId: string,
      writeUser: WriteUser,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersUserIdPut(userId, writeUser, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrganisationUserApi.usersUserIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * OrganisationUserApi - factory interface
 * @export
 */
export const OrganisationUserApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = OrganisationUserApiFp(configuration);
  return {
    /**
     *
     * @summary Get all users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<User>> {
      return localVarFp.usersGet(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersMeGet(options?: RawAxiosRequestConfig): AxiosPromise<User> {
      return localVarFp.usersMeGet(options).then((request) => request(axios, basePath));
    },
    /**
     * An ID will be created in the backend
     * @summary Create user
     * @param {OrganisationUserApiUsersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersPost(
      requestParameters: OrganisationUserApiUsersPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<User> {
      return localVarFp.usersPost(requestParameters.writeUser, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete user by its identifier
     * @param {OrganisationUserApiUsersUserIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdDelete(
      requestParameters: OrganisationUserApiUsersUserIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .usersUserIdDelete(requestParameters.userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get user by its identifier
     * @param {OrganisationUserApiUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdGet(
      requestParameters: OrganisationUserApiUsersUserIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<User> {
      return localVarFp.usersUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update user
     * @param {OrganisationUserApiUsersUserIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdPut(
      requestParameters: OrganisationUserApiUsersUserIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<User> {
      return localVarFp
        .usersUserIdPut(requestParameters.userId, requestParameters.writeUser, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for usersPost operation in OrganisationUserApi.
 * @export
 * @interface OrganisationUserApiUsersPostRequest
 */
export interface OrganisationUserApiUsersPostRequest {
  /**
   *
   * @type {WriteUser}
   * @memberof OrganisationUserApiUsersPost
   */
  readonly writeUser: WriteUser;
}

/**
 * Request parameters for usersUserIdDelete operation in OrganisationUserApi.
 * @export
 * @interface OrganisationUserApiUsersUserIdDeleteRequest
 */
export interface OrganisationUserApiUsersUserIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof OrganisationUserApiUsersUserIdDelete
   */
  readonly userId: string;
}

/**
 * Request parameters for usersUserIdGet operation in OrganisationUserApi.
 * @export
 * @interface OrganisationUserApiUsersUserIdGetRequest
 */
export interface OrganisationUserApiUsersUserIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof OrganisationUserApiUsersUserIdGet
   */
  readonly userId: string;
}

/**
 * Request parameters for usersUserIdPut operation in OrganisationUserApi.
 * @export
 * @interface OrganisationUserApiUsersUserIdPutRequest
 */
export interface OrganisationUserApiUsersUserIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof OrganisationUserApiUsersUserIdPut
   */
  readonly userId: string;

  /**
   *
   * @type {WriteUser}
   * @memberof OrganisationUserApiUsersUserIdPut
   */
  readonly writeUser: WriteUser;
}

/**
 * OrganisationUserApi - object-oriented interface
 * @export
 * @class OrganisationUserApi
 * @extends {BaseAPI}
 */
export class OrganisationUserApi extends BaseAPI {
  /**
   *
   * @summary Get all users
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationUserApi
   */
  public usersGet(options?: RawAxiosRequestConfig) {
    return OrganisationUserApiFp(this.configuration)
      .usersGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get current user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationUserApi
   */
  public usersMeGet(options?: RawAxiosRequestConfig) {
    return OrganisationUserApiFp(this.configuration)
      .usersMeGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * An ID will be created in the backend
   * @summary Create user
   * @param {OrganisationUserApiUsersPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationUserApi
   */
  public usersPost(requestParameters: OrganisationUserApiUsersPostRequest, options?: RawAxiosRequestConfig) {
    return OrganisationUserApiFp(this.configuration)
      .usersPost(requestParameters.writeUser, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete user by its identifier
   * @param {OrganisationUserApiUsersUserIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationUserApi
   */
  public usersUserIdDelete(
    requestParameters: OrganisationUserApiUsersUserIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationUserApiFp(this.configuration)
      .usersUserIdDelete(requestParameters.userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get user by its identifier
   * @param {OrganisationUserApiUsersUserIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationUserApi
   */
  public usersUserIdGet(requestParameters: OrganisationUserApiUsersUserIdGetRequest, options?: RawAxiosRequestConfig) {
    return OrganisationUserApiFp(this.configuration)
      .usersUserIdGet(requestParameters.userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update user
   * @param {OrganisationUserApiUsersUserIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationUserApi
   */
  public usersUserIdPut(requestParameters: OrganisationUserApiUsersUserIdPutRequest, options?: RawAxiosRequestConfig) {
    return OrganisationUserApiFp(this.configuration)
      .usersUserIdPut(requestParameters.userId, requestParameters.writeUser, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
